import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/conta-receber/recorrencia';

export default {
  buscar: (params) =>
    financeiroApi.get(`${PATH}`, {
      params,
    }),
  resgatar: (params) => {
    return financeiroApi.put(`${PATH}/resgatar`, params);
  },
};
